// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2Bu1G","header":"PatientQuestionnaire_header__2B6SL","info":"PatientQuestionnaire_info__h98j5"};